import React from 'react';
import { Modal } from 'semantic-ui-react';
import CloseButton from '../buttons/CloseButton';
import DialogWrapper from './DialogWrapper';
import Actions from '../buttons/Actions';

const Dialog = ({
  children,
  className,
  closeMessageId,
  contentClassName,
  error,
  icon,
  inProgress,
  loading,
  message,
  messageError,
  messageIcon = 'info',
  minimumDataEntryMet,
  onClose,
  onDismiss,
  onSave,
  saveMessageId,
  size = 'tiny',
  theme,
  title,
  values,
  warning,
}) => (
  <DialogWrapper
    className={className}
    error={error}
    icon={icon}
    loading={loading}
    message={message}
    messageError={messageError}
    messageIcon={messageIcon}
    onClose={onClose}
    onDismiss={onDismiss}
    size={size}
    theme={theme}
    title={title}
    values={values}
    warning={warning}
  >
    {children && (<Modal.Content scrolling className={contentClassName}>{children}</Modal.Content>)}
    {!onSave && (<Modal.Actions><CloseButton messageId="actions.close" onClick={onClose} /></Modal.Actions>)}
    {onSave && (
    <Actions
      closeMessageId={closeMessageId}
      inProgress={inProgress}
      minimumDataEntryMet={minimumDataEntryMet}
      onClose={onClose}
      onSave={onSave}
      saveMessageId={saveMessageId}
    />
    )}
  </DialogWrapper>
);

export default Dialog;
